import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-open",
  "use": "icon-open-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-open\"><g stroke=\"currentColor\" fill=\"none\"><path d=\"M14.5 8.5v4.682c0 .728-.584 1.318-1.317 1.318H1.817A1.313 1.313 0 0 1 .5 13.183V1.817C.5 1.09 1.094.5 1.806.5H6.5M7.5 7.5l7-7M9.5.5h5v5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol